import { useCallback } from 'react';
import useApi from '../api/useApi';
import useAuthUser from '../../features/Auth/useAuthUser';

function useLogger() {
  const api = useApi();
  const { getUser } = useAuthUser();

  const info = useCallback(
    async (log: string) => {
      await api.log(log, { type: 'info', user: getUser()?.email });
    },
    [api, getUser]
  );

  const error = useCallback(
    async (message: string, errorContext: unknown) => {
      await api.log(message, {
        type: 'error',
        user: getUser()?.email,
        error: JSON.stringify(errorContext, Object.getOwnPropertyNames(errorContext)),
      });
    },
    [api, getUser]
  );

  return { info, error };
}

export default useLogger;
